import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IDirectDealFilter } from '../../constants/filter/directDealFilter.constant';
import { pageInfo } from '../../constants/pageInfo/pageInfo.constant';
import { createSearchParamBySelectedFilterOption } from '../../utils/filter/createSearchParamBySelectedFilterOption.util';
import { useAppSelector } from '../store/useStore';

export const useUpdateDirectDealListPageSearchParam = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const directDealFilterStates = useAppSelector((state) => state.filter.directDealFilter);

  useEffect(() => {
    if (directDealFilterStates.isSearchParamChecked && directDealFilterStates.globalFilters) {
      const existingParams = Object.fromEntries(searchParams.entries());

      const newFilterParams = createSearchParamBySelectedFilterOption({
        filterType: 'directDealFilter',
        filters: directDealFilterStates.globalFilters as IDirectDealFilter[],
      });

      const mergedParams = {
        ...existingParams,
        ...newFilterParams,
      };

      const newSearchParams = new URLSearchParams(mergedParams).toString();

      navigate(`${pageInfo.openMarketListPage.path}?${newSearchParams}`, {
        replace: true,
      });
    }
  }, [directDealFilterStates.globalFilters, directDealFilterStates.isSearchParamChecked, searchParams, navigate]);
};
